import { useAppDispatch, useAppSelector, useAppStore } from '~/store/hooks'
import { mostRecentSelectedObjectOfClassName } from 'store/selectedObjects/selectors'
import CLASS_NAMES from '~/config/objectClassNames'
import { ElevationPoint } from '~/store/objects/types'
import Panel, { PanelSection } from '~/components/UIKit/Panel'
import { SELECTED_ELEVATION_POINT_PANEL } from '~/store/panel/types'
import { updateElevationLine, updateElevationPoint } from '~/store/objects'
import { DimensionInput } from '~/ui/DimensionInput'
import { modelToUI, uiToModel } from '~/components/DrawingCanvas/util/units'
import { MetadataFields } from '~/components/MetadataFields'

export default function SelectedElevationPointPanel() {
  const point = useAppSelector(it => mostRecentSelectedObjectOfClassName(CLASS_NAMES.ELEVATION_POINT, it))
  const dispatch = useAppDispatch()
  const store = useAppStore()
  const update = (elevationPoint: ElevationPoint) => dispatch(updateElevationPoint({ elevationPoint }))

  return (
    <Panel title="Elevation Point" alignment="right" docked panelKey={SELECTED_ELEVATION_POINT_PANEL}>
      {point && (
        <>
          <PanelSection>
            <DimensionInput
              label="Height"
              value={uiToModel(point.position.z)}
              onCommit={value => {
                const { elevationLines } = store.getState().objects.present
                const parentLine = Object.values(elevationLines).find(line =>
                  line.elevationPointIds.find(id => id === point.id)
                )

                // disconnect the parent line's height if we're changing ours explicitly
                if (parentLine !== undefined) {
                  dispatch(
                    updateElevationLine({
                      elevationLine: {
                        ...parentLine,
                        height: undefined,
                      },
                    })
                  )
                }

                update({ ...point, position: { ...point.position, z: modelToUI(value) } })
              }}
            />
          </PanelSection>
          <MetadataFields
            onChange={(fieldName, newValue) => {
              dispatch(
                updateElevationPoint({
                  elevationPoint: {
                    ...point,
                    metadata: { ...point.metadata, [fieldName]: newValue },
                  },
                })
              )
            }}
            onDeleteImage={elevationPoint => dispatch(updateElevationPoint({ elevationPoint }))}
            selectedObjects={[point]}
          />
        </>
      )}
    </Panel>
  )
}
